import React from 'react';
import { observer } from 'mobx-react-lite';
import { BasePieChart } from './base/pie/base-pie-chart';
import { useRootStore } from '../../../providers/root-store-provider';
import { PieChartTypeEnum } from '../../../models/enums/pie-chart-type-enum';

type SectorChartType = {
    isFree?: boolean;
    isFullScreen?: boolean;
    includeMinorCategories?: boolean;
};

export const SectorChart: React.FC<SectorChartType> = observer(
    ({ isFree = false, isFullScreen, includeMinorCategories }: SectorChartType) => {
        const { portfolioStore, statisticStore } = useRootStore();
        const { sectorRatio, sectorRatioFullScreen } = statisticStore.ratiosStore;

        React.useEffect(() => {
            if (includeMinorCategories && !sectorRatioFullScreen) {
                statisticStore.ratiosStore.fetchRatios(true);
            }
        }, [includeMinorCategories, sectorRatioFullScreen, statisticStore.ratiosStore]);

        const chartData = includeMinorCategories ? sectorRatioFullScreen : sectorRatio;

        if (!chartData) {
            return null;
        }

        return (
            <BasePieChart
                currency={portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode}
                type={PieChartTypeEnum.Sector}
                data={chartData.data}
                isFree={isFree}
                isFullScreen={isFullScreen}
            />
        );
    },
);
